import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { ClassInsightsState, ClassInsightsStore } from './class-insights.store';
import { ClassInsightsStoreModel, ClassInsightsUIModel } from './class-insights.model';

@Injectable({ providedIn: 'root' })
export class ClassInsightsQuery extends QueryEntity<
  ClassInsightsState,
  ClassInsightsStoreModel,
  ClassInsightsUIModel,
  'classId'
> {
  constructor(protected override readonly store: ClassInsightsStore) {
    super(store);
  }

  override readonly toUIModelFn = (entity: ClassInsightsStoreModel): ClassInsightsUIModel => {
    const courseCoveragePercent =
      entity.courseCoverageTotalTopics > 0
        ? Math.round((entity.courseCoverageCompletedTopics / entity.courseCoverageTotalTopics) * 100)
        : 0;

    return {
      ...entity,
      courseCoveragePercent,
    };
  };
}
